import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { BudgetPickerContentModal } from '../../../../forms/budget-picker/BudgetPickerContentModal'

export type BudgetPickerProps = {
  field: ControllerRenderProps<FieldValues, string>
  onValid: () => void
}

export const BudgetPicker = ({ field, onValid }: BudgetPickerProps) => {
  return <BudgetPickerContentModal field={field} onValid={onValid} />
}
